export const PropsCompanyMain = {
  titulo: "NUESTRA EMPRESA",
  textoPrincipal:
    "Somos una empresa peruana especializada en <strong>DIGITACIÓN</strong> masiva de datos (encuestas, fichas, cupones, formularios, etc.), <strong>DIGITALIZACIÓN</strong> (escaneo) de documentos, fotos o diapositivas y TRANSCRIPCIÓN de audio / video a texto.Brindamos nuestros servicios a EMPRESAS y PERSONAS NATURALES a nivel NACIONAL e INTERNACIONAL.",
  textoSecundario:
    "Obtendrás un servicio de calidad, con total puntualidad y confidencialidad.",
};
